"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentApplyApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var AgentApplyApi = /** @class */ (function () {
    function AgentApplyApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 查询代理申请
     * @method GET 查询代理申请
     *
     */
    AgentApplyApi.prototype.AgentApply = function () {
        return this.http
            .url("/api/AgentApply")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 设置是否批准
     * @method PUT 设置是否批准
     *
     * @params id 无说明
     */
    AgentApplyApi.prototype.AgentApplyById = function (id) {
        return this.http
            .url("/api/AgentApply/" + id)
            .addSecurityHeaders()
            .support('PUT');
    };
    AgentApplyApi.diOptions = di_1.default.options({
        name: "AgentApplyApi",
        scope: "Singleton"
    });
    return AgentApplyApi;
}());
exports.AgentApplyApi = AgentApplyApi;
exports.default = AgentApplyApi;
